import React from 'react'
import { useRefreshMediaRect } from '@/utils/hooks'

export default function Comp({
    props,
    rectOptions,
    currentIndex
}) {
    const { subRectOptions } = rectOptions
    const { subProps } = props
    const { width, height, left, top } = subRectOptions[currentIndex]
    const { imageUrl } = subProps[currentIndex]
    useRefreshMediaRect(imageUrl, subRectOptions[currentIndex])
    return (
        <div
            style={{
                position: 'absolute',
                width,
                height,
                overflow: 'hidden',
                transform: `translate(${left}px, ${top}px)`
            }}
        >
            <img
                src={imageUrl}
                alt=""
                style={{
                    width: '100%',
                    height: '100%',
                }}
            />
        </div>
    )
}